export default "__VITE_ASSET__nGlK7sSD__"